import axios from 'axios';
import { API_URL } from '../../../config';

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

export async function fetchStatisticsFilters() {
  const { data } = await api.get('/statistics/filters');
  return data;
}

export async function fetchStatisticsMarketTrends(payload) {
  const { data } = await api.post('/statistics/market-trends', payload);
  return data;
}
